import { apiFetch } from "./client";

export interface AgentChannel {
  id: string;
  agentId: string;
  name: string;
  slug: string;
  description: string | null;
  color: string;
  iconEmoji: string | null;
  shared: boolean;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreateChannelInput {
  name: string;
  description?: string;
  color?: string;
  iconEmoji?: string;
  shared?: boolean;
  sortOrder?: number;
}

export const agentChannelsApi = {
  list: (agentId: string) =>
    apiFetch<AgentChannel[]>(`/agents/${agentId}/channels`),

  create: (agentId: string, data: CreateChannelInput) =>
    apiFetch<AgentChannel>(`/agents/${agentId}/channels`, {
      method: "POST",
      body: JSON.stringify(data),
    }),

  update: (agentId: string, channelId: string, data: Partial<CreateChannelInput>) =>
    apiFetch<AgentChannel>(`/agents/${agentId}/channels/${channelId}`, {
      method: "PATCH",
      body: JSON.stringify(data),
    }),

  delete: (agentId: string, channelId: string) =>
    apiFetch<void>(`/agents/${agentId}/channels/${channelId}`, {
      method: "DELETE",
    }),

  /** Persist a new channel order. `orderedIds` is the full list of channel
   *  ids in the desired top-to-bottom order; the server writes each one's
   *  sortOrder to its index. Returns the reordered channel list. */
  reorder: (agentId: string, orderedIds: string[]) =>
    apiFetch<AgentChannel[]>(`/agents/${agentId}/channels/reorder`, {
      method: "PATCH",
      body: JSON.stringify({ orderedIds }),
    }),
};
